var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeafs = function SvgLeafs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 108,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: "319.004%",
    y1: "50%",
    x2: "99.844%",
    x1: "110.223%",
    id: "leafs_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "319.004%",
    y1: "50%",
    x2: "147.695%",
    x1: "168.038%",
    id: "leafs_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "319.004%",
    y1: "50%",
    x2: "130.74%",
    x1: "147.552%",
    id: "leafs_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "319.004%",
    y1: "50%",
    x2: "177.602%",
    x1: "204.171%",
    id: "leafs_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "257.437%",
    y1: "50%",
    x2: "244.585%",
    x1: "285.102%",
    id: "leafs_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "156.317%",
    y1: "50%",
    x2: "244.585%",
    x1: "285.102%",
    id: "leafs_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "128.11%",
    y1: "50%",
    x2: "244.585%",
    x1: "285.102%",
    id: "leafs_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "319.004%",
    y1: "50%",
    x2: "92.643%",
    x1: "101.522%",
    id: "leafs_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616172",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h62v110H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.392 32.15s3.743-5.272 1.322-12.596C14.285 12.236 8.63 9.456 8.63 9.456S4.396 15.74 6.762 22.874c2.361 7.139 8.63 9.277 8.63 9.277v-.001z",
    fill: "url(#leafs_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.064 39.716s6.706-.528 10.546-6.426c3.84-5.894.905-12.486.905-12.486s-6.226 1.243-10.17 7.294c-3.94 6.048-1.281 11.618-1.281 11.618z",
    fill: "url(#leafs_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.526 48.492c-3.367 6.69.29 12.027.29 12.027s7.142-1.428 10.42-7.943c3.272-6.525-.832-12.86-.832-12.86s-6.512 2.085-9.878 8.776z",
    fill: "url(#leafs_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.548 56.737s-5.656 2.796-8.068 10.113c-2.411 7.331 1.35 12.582 1.35 12.582s6.27-2.155 8.622-9.292c2.348-7.138-1.904-13.403-1.904-13.403zm5.787 37.824s5.974-3.842 6.378-11.048c.4-7.211-5.895-11.646-5.895-11.646s-5.138 4.237-5.551 11.632c-.409 7.391 5.068 11.062 5.068 11.062zM24.388 22.695s6.139-2.09 7.938-9.555C34.131 5.674 30.643 0 30.643 0s-7.11 2.627-8.87 9.91c-1.754 7.28 2.615 12.785 2.615 12.785z",
    fill: "url(#leafs_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.016 52.954s2.39-6.056-2.376-12.077c-4.774-6.025-11.61-6.835-11.61-6.835s-2.61 7.144 2.038 13.017c4.648 5.877 11.948 5.895 11.948 5.895z",
    fill: "url(#leafs_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.397 71.643s.87-6.163-4.874-10.836C8.77 56.129 2.259 56.766 2.259 56.766s-.839 7.23 4.763 11.787c5.61 4.553 12.375 3.09 12.375 3.09z",
    fill: "url(#leafs_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.016 86.977s-1.096-6.8-8.065-9.874c-6.973-3.085-12.993-.301-12.993-.301s1.476 7.917 8.265 10.925c6.79 2.994 12.793-.75 12.793-.75z",
    fill: "url(#leafs_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.714 95.205c-6.939-1.981-12.356 1.244-12.356 1.244s2.243 7.008 9.002 8.942c6.767 1.933 12.056-2.165 12.056-2.165s-1.764-6.044-8.702-8.02v-.001z",
    fill: "url(#leafs_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.527 26.115-3.575-1.751c-.188.39-18.576 39.311 33.092 83.324l2.585-3.014C7.436 62.762 23.804 27.59 24.527 26.115z",
    fill: "url(#leafs_svg__h)"
  }))));
};
export { SvgLeafs as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iMTA4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGRlZnM+CiAgPGxpbmVhckdyYWRpZW50IHkyPSIzMTkuMDA0JSIgeTE9IjUwJSIgeDI9Ijk5Ljg0NCUiIHgxPSIxMTAuMjIzJSIgaWQ9InByZWZpeF9fYSI+CiAgIDxzdG9wIHN0b3AtY29sb3I9IiNDQUNBREIiIG9mZnNldD0iMCUiLz4KICAgPHN0b3Agc3RvcC1jb2xvcj0iIzYxNjE3MiIgb2Zmc2V0PSIxMDAlIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8bGluZWFyR3JhZGllbnQgeTI9IjMxOS4wMDQlIiB5MT0iNTAlIiB4Mj0iMTQ3LjY5NSUiIHgxPSIxNjguMDM4JSIgaWQ9InByZWZpeF9fYiI+CiAgIDxzdG9wIHN0b3AtY29sb3I9IiNDQUNBREIiIG9mZnNldD0iMCUiLz4KICAgPHN0b3Agc3RvcC1jb2xvcj0iIzYxNjE3MiIgb2Zmc2V0PSIxMDAlIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8bGluZWFyR3JhZGllbnQgeTI9IjMxOS4wMDQlIiB5MT0iNTAlIiB4Mj0iMTMwLjc0JSIgeDE9IjE0Ny41NTIlIiBpZD0icHJlZml4X19jIj4KICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NBQ0FEQiIgb2Zmc2V0PSIwJSIvPgogICA8c3RvcCBzdG9wLWNvbG9yPSIjNjE2MTcyIiBvZmZzZXQ9IjEwMCUiLz4KICA8L2xpbmVhckdyYWRpZW50PgogIDxsaW5lYXJHcmFkaWVudCB5Mj0iMzE5LjAwNCUiIHkxPSI1MCUiIHgyPSIxNzcuNjAyJSIgeDE9IjIwNC4xNzElIiBpZD0icHJlZml4X19kIj4KICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NBQ0FEQiIgb2Zmc2V0PSIwJSIvPgogICA8c3RvcCBzdG9wLWNvbG9yPSIjNjE2MTcyIiBvZmZzZXQ9IjEwMCUiLz4KICA8L2xpbmVhckdyYWRpZW50PgogIDxsaW5lYXJHcmFkaWVudCB5Mj0iMjU3LjQzNyUiIHkxPSI1MCUiIHgyPSIyNDQuNTg1JSIgeDE9IjI4NS4xMDIlIiBpZD0icHJlZml4X19lIj4KICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NBQ0FEQiIgb2Zmc2V0PSIwJSIvPgogICA8c3RvcCBzdG9wLWNvbG9yPSIjNjE2MTcyIiBvZmZzZXQ9IjEwMCUiLz4KICA8L2xpbmVhckdyYWRpZW50PgogIDxsaW5lYXJHcmFkaWVudCB5Mj0iMTU2LjMxNyUiIHkxPSI1MCUiIHgyPSIyNDQuNTg1JSIgeDE9IjI4NS4xMDIlIiBpZD0icHJlZml4X19mIj4KICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NBQ0FEQiIgb2Zmc2V0PSIwJSIvPgogICA8c3RvcCBzdG9wLWNvbG9yPSIjNjE2MTcyIiBvZmZzZXQ9IjEwMCUiLz4KICA8L2xpbmVhckdyYWRpZW50PgogIDxsaW5lYXJHcmFkaWVudCB5Mj0iMTI4LjExJSIgeTE9IjUwJSIgeDI9IjI0NC41ODUlIiB4MT0iMjg1LjEwMiUiIGlkPSJwcmVmaXhfX2ciPgogICA8c3RvcCBzdG9wLWNvbG9yPSIjQ0FDQURCIiBvZmZzZXQ9IjAlIi8+CiAgIDxzdG9wIHN0b3AtY29sb3I9IiM2MTYxNzIiIG9mZnNldD0iMTAwJSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPGxpbmVhckdyYWRpZW50IHkyPSIzMTkuMDA0JSIgeTE9IjUwJSIgeDI9IjkyLjY0MyUiIHgxPSIxMDEuNTIyJSIgaWQ9InByZWZpeF9faCI+CiAgIDxzdG9wIHN0b3AtY29sb3I9IiNDQUNBREIiIG9mZnNldD0iMCUiLz4KICAgPHN0b3Agc3RvcC1jb2xvcj0iIzYxNjE3MiIgb2Zmc2V0PSIxMDAlIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KIDwvZGVmcz4KIDxnPgogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4KICA8cmVjdCBmaWxsPSJub25lIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iMTEwIiB3aWR0aD0iNjIiIHk9Ii0xIiB4PSItMSIvPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxnIGlkPSJzdmdfMSIgb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9Im5vbmUiPgogICA8ZyBpZD0ic3ZnXzIiPgogICAgPHBhdGggaWQ9InN2Z18zIiBkPSJtMTUuMzkyLDMyLjE1czMuNzQzLC01LjI3MiAxLjMyMiwtMTIuNTk2Yy0yLjQyOSwtNy4zMTggLTguMDg0LC0xMC4wOTggLTguMDg0LC0xMC4wOThzLTQuMjM0LDYuMjg0IC0xLjg2OCwxMy40MThjMi4zNjEsNy4xMzkgOC42Myw5LjI3NyA4LjYzLDkuMjc3bDAsLTAuMDAxeiIgZmlsbD0idXJsKCNwcmVmaXhfX2EpIi8+CiAgICA8cGF0aCBpZD0ic3ZnXzQiIGQ9Im0yNi4wNjQsMzkuNzE2czYuNzA2LC0wLjUyOCAxMC41NDYsLTYuNDI2YzMuODQsLTUuODk0IDAuOTA1LC0xMi40ODYgMC45MDUsLTEyLjQ4NnMtNi4yMjYsMS4yNDMgLTEwLjE3LDcuMjk0Yy0zLjk0LDYuMDQ4IC0xLjI4MSwxMS42MTggLTEuMjgxLDExLjYxOHoiIGZpbGw9InVybCgjcHJlZml4X19iKSIvPgogICAgPHBhdGggaWQ9InN2Z181IiBkPSJtMjguNTI2LDQ4LjQ5MmMtMy4zNjcsNi42OSAwLjI5LDEyLjAyNyAwLjI5LDEyLjAyN3M3LjE0MiwtMS40MjggMTAuNDIsLTcuOTQzYzMuMjcyLC02LjUyNSAtMC44MzIsLTEyLjg2IC0wLjgzMiwtMTIuODZzLTYuNTEyLDIuMDg1IC05Ljg3OCw4Ljc3NnoiIGZpbGw9InVybCgjcHJlZml4X19jKSIvPgogICAgPHBhdGggaWQ9InN2Z182IiBkPSJtNDUuNTQ4LDU2LjczN3MtNS42NTYsMi43OTYgLTguMDY4LDEwLjExM2MtMi40MTEsNy4zMzEgMS4zNSwxMi41ODIgMS4zNSwxMi41ODJzNi4yNywtMi4xNTUgOC42MjIsLTkuMjkyYzIuMzQ4LC03LjEzOCAtMS45MDQsLTEzLjQwMyAtMS45MDQsLTEzLjQwM3ptNS43ODcsMzcuODI0czUuOTc0LC0zLjg0MiA2LjM3OCwtMTEuMDQ4YzAuNCwtNy4yMTEgLTUuODk1LC0xMS42NDYgLTUuODk1LC0xMS42NDZzLTUuMTM4LDQuMjM3IC01LjU1MSwxMS42MzJjLTAuNDA5LDcuMzkxIDUuMDY4LDExLjA2MiA1LjA2OCwxMS4wNjJ6bS0yNi45NDcsLTcxLjg2NnM2LjEzOSwtMi4wOSA3LjkzOCwtOS41NTVjMS44MDUsLTcuNDY2IC0xLjY4MywtMTMuMTQgLTEuNjgzLC0xMy4xNHMtNy4xMSwyLjYyNyAtOC44Nyw5LjkxYy0xLjc1NCw3LjI4IDIuNjE1LDEyLjc4NSAyLjYxNSwxMi43ODV6IiBmaWxsPSJ1cmwoI3ByZWZpeF9fYSkiLz4KICAgIDxwYXRoIGlkPSJzdmdfNyIgZD0ibTE1LjAxNiw1Mi45NTRzMi4zOSwtNi4wNTYgLTIuMzc2LC0xMi4wNzdjLTQuNzc0LC02LjAyNSAtMTEuNjEsLTYuODM1IC0xMS42MSwtNi44MzVzLTIuNjEsNy4xNDQgMi4wMzgsMTMuMDE3YzQuNjQ4LDUuODc3IDExLjk0OCw1Ljg5NSAxMS45NDgsNS44OTV6IiBmaWxsPSJ1cmwoI3ByZWZpeF9fZCkiLz4KICAgIDxwYXRoIGlkPSJzdmdfOCIgZD0ibTE5LjM5Nyw3MS42NDNzMC44NywtNi4xNjMgLTQuODc0LC0xMC44MzZjLTUuNzUzLC00LjY3OCAtMTIuMjY0LC00LjA0MSAtMTIuMjY0LC00LjA0MXMtMC44MzksNy4yMyA0Ljc2MywxMS43ODdjNS42MSw0LjU1MyAxMi4zNzUsMy4wOSAxMi4zNzUsMy4wOXoiIGZpbGw9InVybCgjcHJlZml4X19lKSIvPgogICAgPHBhdGggaWQ9InN2Z185IiBkPSJtMjkuMDE2LDg2Ljk3N3MtMS4wOTYsLTYuOCAtOC4wNjUsLTkuODc0Yy02Ljk3MywtMy4wODUgLTEyLjk5MywtMC4zMDEgLTEyLjk5MywtMC4zMDFzMS40NzYsNy45MTcgOC4yNjUsMTAuOTI1YzYuNzksMi45OTQgMTIuNzkzLC0wLjc1IDEyLjc5MywtMC43NXoiIGZpbGw9InVybCgjcHJlZml4X19mKSIvPgogICAgPHBhdGggaWQ9InN2Z18xMCIgZD0ibTMzLjcxNCw5NS4yMDVjLTYuOTM5LC0xLjk4MSAtMTIuMzU2LDEuMjQ0IC0xMi4zNTYsMS4yNDRzMi4yNDMsNy4wMDggOS4wMDIsOC45NDJjNi43NjcsMS45MzMgMTIuMDU2LC0yLjE2NSAxMi4wNTYsLTIuMTY1cy0xLjc2NCwtNi4wNDQgLTguNzAyLC04LjAybDAsLTAuMDAxeiIgZmlsbD0idXJsKCNwcmVmaXhfX2cpIi8+CiAgICA8cGF0aCBpZD0ic3ZnXzExIiBkPSJtMjQuNTI3LDI2LjExNWwtMy41NzUsLTEuNzUxYy0wLjE4OCwwLjM5IC0xOC41NzYsMzkuMzExIDMzLjA5Miw4My4zMjRsMi41ODUsLTMuMDE0Yy00OS4xOTMsLTQxLjkxMiAtMzIuODI1LC03Ny4wODQgLTMyLjEwMiwtNzguNTU5eiIgZmlsbD0idXJsKCNwcmVmaXhfX2gpIi8+CiAgIDwvZz4KICA8L2c+CiA8L2c+Cjwvc3ZnPg==";